// extracted by mini-css-extract-plugin
export default {"thankYouContainer":"thankYouPage_thankYouContainer__PumMQ","textContainer":"thankYouPage_textContainer__Wtvgx","redirectText":"thankYouPage_redirectText__UQrrC"};